import React from 'react';
import { AlertTriangle, Package } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { NativeModal } from '@/components/primitives/NativeModal';
import { t } from '@/constants/i18n';

export interface StockLimitDialogProps {
    open: boolean;
    onClose: () => void;
    maxQuantity: number;
    requestedQuantity?: number;
    onExited?: () => void;
}

export const StockLimitDialog: React.FC<StockLimitDialogProps> = ({
    open,
    onClose,
    maxQuantity,
    requestedQuantity,
    onExited
}) => {
    return (
        <NativeModal
            isOpen={open}
            onClose={onClose}
            onExited={onExited}
        >
            {/* 移植了视觉样式容器: bg-white, rounded-2xl, shadow-xl */}
            <div
                data-testid="stock-limit-dialog"
                className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 relative focus:outline-none text-center"
            >
                {/* 1. 图标区域: 更大的圆圈和柔和的红色背景 */}
                <div className="flex justify-center mb-5 mt-2">
                    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-50">
                        <AlertTriangle className="h-8 w-8 text-red-600" strokeWidth={1.5} />
                    </div>
                </div>

                {/* 2. Title */}
                <h2 className="text-xl font-bold leading-tight text-gray-900 mb-2">
                    {t('stockLimitTitle')}
                </h2>

                {/* 3. Description */}
                <div className="mt-2 mb-6">
                    <p className="text-sm text-gray-500 leading-relaxed px-2">
                        {requestedQuantity
                            ? t('stockLimitDescRequested', maxQuantity.toString())
                            : t('stockLimitDescDefault', maxQuantity.toString())}
                    </p>
                </div>

                {/* 4. Stock Badge: 移植了红色胶囊样式 */}
                <div className="flex justify-center">
                    <Badge
                        variant="secondary" // 使用 secondary 避免默认 destructive 样式的干扰
                        onClick={onClose}
                        className="inline-flex items-center gap-1.5 rounded-full bg-red-600 px-4 py-1.5 text-xs font-semibold text-white hover:bg-red-700 border-none shadow-sm cursor-pointer"
                    >
                        <Package className="h-3.5 w-3.5" />
                        <span>{t('stockLimitAvailable', maxQuantity.toString())}</span>
                    </Badge>
                </div>
            </div>
        </NativeModal>
    );
};
